<template lang="html">
    <div class="container-fluid p-5">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h5 class="mb-0">Enrollment Report List</h5>
                        <div class="d-flex align-items-center">
                            <button class="btn btn-primary" @click="exportCsv()">
                                <i class="fas fa-upload"></i> Export CSV
                            </button>
                        </div>  
                    </div>
                    <div class="card-body">
                        <div class="row search-form">
                            <div class="col-md-3 mt-1">
                                <input type="text" v-model="filter.search_batch" class="form-control" placeholder="Search by Batch Code, Batch Name">
                            </div>
                            <div class="col-md-3 mt-1">
                                <input type="text" v-model="filter.search_fee" class="form-control" placeholder="Search by Fee Code, Fee Name">
                            </div>
                            <div class="col-md-3 mt-1">
                                <input type="text" v-model="filter.search_student" class="form-control" placeholder="Search by Student Code, Student Name">
                            </div>
                            <div class="col-md-3 mt-1">
                                <select v-model="filter.status" class="form-control">
                                    <option value="">Select Status</option>
                                    <option value="pending">Pending</option>
                                    <option value="partial">Partial</option>
                                    <option value="done">Done</option>
                                </select>
                            </div>
                            <div class="col-md-3 mt-1">
                                <input onfocus="(this.type='date')" v-model="filter.date_from" class="form-control" placeholder="From Date">
                            </div>
                            <div class="col-md-3 mt-1">
                                <input onfocus="(this.type='date')" v-model="filter.date_to" class="form-control" placeholder="To Date">
                            </div>
                            <div class="col-md-3 mt-1">
                                <button class="btn btn-primary mr-1 fbutton" @click="search()"><i class="fas fa-search"></i> Search</button>
                                <button class="btn btn-info fbutton" @click="reset()"><i class="fas fa-sync"></i> Refresh</button>
                            </div>
                        </div>
                        <div class="table-responsive mt-4">
                            <table class="common-table">
                                <thead>
                                    <tr>
                                        <th v-for="(value, key) in visibleColumns" :key="key" @click="sortBy(key)" style="cursor:pointer">
                                            {{ value }}
                                            <span v-if="filter.sort_by === key">
                                                <i v-if="filter.orderBy === 'asc'" class="fas fa-sort-up"></i>
                                                <i v-else class="fas fa-sort-down"></i>
                                            </span>
                                        </th>
                                        <!-- <th>Actions</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(data, index) in dataList" :key="data.id">
                                        <td>{{ data.batch.code1 }}{{ data.batch.code2 }}{{ data.batch.code3 }}</td>
                                        <td>{{ data.fee.code }}</td>
                                        <td>{{ data.payment_terms.name }}</td>
                                        <td>{{ data.student.student_code }}</td>
                                        <td>{{ data.student.name }}</td>
                                        <td v-if="user.type == 'a1'">{{ data.original_amount }}</td>
                                        <td>{{ data.discount_amount }}</td>
                                        <td>{{ data.amount }}</td>
                                        <td v-if="user.type == 'a1'">{{ data.remain_amount }}</td>
                                        <td>{{ data.enrollment_date }}</td>
                                        <td>
                                            <span v-if="data.status == 'pending'" class="badge badge-success">Pending</span>
                                            <span v-else-if="data.status == 'active'" class="badge badge-info">Active</span>
                                            <span v-else-if="data.status == 'partial'" class="badge badge-info">Partial</span>
                                            <span v-else-if="data.status == 'done'" class="badge badge-success">Done</span>
                                            <span v-else class="badge badge-danger">Inactive</span>
                                        </td>
                                    </tr>
                                    <tr v-if="dataList.length > 0" class="table-summary font-weight-bold text-white" style="background-color: #4e8889;">
                                        <td class="text-center" colspan="5">
                                           TOTAL
                                        </td>
                                        <td v-if="user.type == 'a1'">{{ totalData.original_amount }}</td>
                                        <td>{{ totalData.discount_amount }}</td>
                                        <td>{{ totalData.amount }}</td>
                                        <td v-if="user.type == 'a1'">{{ totalData.remain_amount }}</td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr v-if="dataList.length === 0">
                                        <td :colspan="Object.keys(columns).length + 1" class="text-center">Empty List</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="table-pagination-minimal">
                            <div class="table-pagination-row">
                                <div v-if="dataList.length > 0 " class="table-info-minimal left-align">
                                    Showing <span>{{metaData.from}}</span> to <span>{{metaData.to}}</span> of <span>{{metaData.total}}</span> entries
                                </div>
                                <nav class="pagination-minimal">
                                    <ul>
                                        <li :class="{ 'disabled': metaData.prev_page_url === null }">
                                            <button @click.prevent="next(metaData.current_page-1)" :disabled="metaData.prev_page_url === null">
                                                <i class="fas fa-angle-left"></i>
                                            </button>
                                        </li>
                                        <li v-for="page in metaData.last_page" :key="page"
                                            :class="{ 'active':metaData.current_page === page }"
                                            v-if="Math.abs(page - metaData.current_page) < 3 || page == metaData.last_page || page == 1">
                                            <button @click.prevent="next(page)">{{ page }}</button>
                                        </li>
                                        <li :class="{ 'disabled': metaData.current_page === metaData.last_page }">
                                            <button @click.prevent="next(metaData.current_page+1)" :disabled="metaData.current_page === metaData.last_page">
                                                <i class="fas fa-angle-right"></i>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                        <b-modal id="bv-modal-delete" ref="my-modal" title="Delete" hide-footer>
                            <p class="my-4">Are you sure to delete ? </p>
                            <p class="my-4 text-danger">{{alert}}</p>
                            <b-button class="mt-3 btn-danger" block @click="deleteItem()">Delete</b-button>
                        </b-modal>
                        
                        <!-- CSV Upload Modal -->
                        <b-modal id="bv-modal-csv-upload" ref="csv-modal" title="Import Enrollments (CSV)" hide-footer size="md">
                            <template>
                                <div v-if="uploadMessage" :class="uploadMessageType === 'success' ? 'alert alert-success' : 'alert alert-danger'">
                                    {{ uploadMessage }}
                                </div>
                                <div class="form-group">
                                    <label for="csvFile">Select CSV File</label>
                                    <input 
                                        type="file" 
                                        id="csvFile" 
                                        ref="csvFileInput"
                                        @change="onFileSelect" 
                                        accept=".csv" 
                                        class="form-control"
                                    />
                                    <small class="form-text text-muted">
                                        Please upload a CSV file with the required enrollment data format.
                                    </small>
                                </div>
                                <div class="form-group" v-if="selectedFile">
                                    <strong>Selected File:</strong> {{ selectedFile.name }}<br>
                                    <strong>Size:</strong> {{ formatFileSize(selectedFile.size) }}
                                </div>
                                <div class="d-flex justify-content-between">
                                    <b-button variant="secondary" @click="closeUploadModal()">Cancel</b-button>
                                    <b-button variant="primary" @click="uploadCSV()" :disabled="!selectedFile || isUploading">
                                        <span v-if="isUploading">
                                            <i class="fas fa-spinner fa-spin"></i> Uploading...
                                        </span>
                                        <span v-else>
                                            <i class="fas fa-upload"></i> Upload
                                        </span>
                                    </b-button>
                                </div>
                            </template>
                        </b-modal>
                        
                        <!-- <router-link class="float" to="enrollment-create">
                            <i class="fa fa-plus my-float" style="padding: 37%;"></i>
                        </router-link> -->
                    </div> <!-- close card-body -->
                </div> <!-- close card -->
            </div> <!-- close col-md-12 -->
        </div> <!-- close row -->
    </div> <!-- close container-fluid -->
</template>

<script lang="js">
    import {
        mapState,
        mapActions
    } from 'vuex'
    import env from '../../enviorments'
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
        name: 'enrollmentReportList',
        metaInfo: {
            title: "Enrollment Report List",
            titleTemplate: "%s ← MIC",
        },
        components: {
            Loading
        },
        data() {
            return {
                env,
                isLoading: false,
                fullPage: true,
                user: null,
                alert: "",
                id: '',
                dataList: [],
                commissionData: [],
                permissions: '',
                columns: {
                    batch_id: "Batch Code",
                    fee_id: "Fee Code",
                    payment_terms_id: "Payment Terms",
                    student_code: "Student Code",
                    name: "Student Name",
                    original_amount: "Original Fee",
                    discount_amount: "Discount Amount",
                    amount: "Total Fee",
                    remain_amount: "Remaining Amount",
                    enrollment_date: "Enrollment Date",
                    status: "Received Status",
                },
                filter: {
                    page: 1,
                    per_page: 20,
                    sort_direction: "asc",
                    sort_by: "created_at",
                    limit: 20,
                    search_batch: '',
                    search_fee: '',
                    search_student: '',
                    status: '',
                    date_from: '',
                    date_to: ''
                },
                metaData: {
                    last_page: null,
                    current_page: 1,
                    from: null,
                    to: null,
                    total: null,
                    prev_page_url: null
                },
                // CSV Upload related data
                selectedFile: null,
                isUploading: false,
                uploadMessage: '',
                uploadMessageType: 'success'
            }
        },
        watch: {
        '$route' (to, from) {
            this.fetchData()
        }
    },
         computed: {
            visibleColumns() {
                // return columns but omit original_amount unless user.type == 'a1'
                const cols = Object.assign({}, this.columns);
                if (!(this.user && this.user.type == 'a1')) {
                    delete cols.original_amount;
                    delete cols.remain_amount;
                }
                return cols;
            },
            visibleColumnsCount() {
                return Object.keys(this.visibleColumns).length;
            }
        },
        methods: {
            ...mapActions({
                enrollmentListAction: 'enrollmentListAction',
                getEnrollmentCsvExportAction: 'getEnrollmentCsvExportAction',
                bankDeleteAction: 'bankDeleteAction',
                enrollmentImportAction: 'enrollmentImportAction',
                enrollmentTotalAction: 'enrollmentTotalAction'
            }),
            sortBy(column) {
                this.filter.sort_by = column
                if (this.filter.sort_by == column) {
                    if (this.filter.sort_direction == "asc") {
                        this.filter.sort_direction = "desc"
                    } else if (this.filter.sort_direction == "desc") {
                        this.filter.sort_direction = "asc"
                    }
                } else {
                    this.filter.sort_direction = "asc"
                }
                this.fetchData()
            },
            async search() {
                this.filter.page = 1
                this.fetchData()
                this.$refs['my-modal'].hide()
            },
            async exportCsv() {
                this.isLoading = true;
                let option = this.filter
                await this.getEnrollmentCsvExportAction({
                    ...option
                }).then(res => {
                    if (res.success == true && res.data.download_url) {
                        console.log('Download URL:', res.data.download_url);
                        
                        // Create a temporary link element to download the file
                        const link = document.createElement('a');
                        link.href = res.data.download_url;
                        link.download = `receipt_report_${new Date().toISOString().slice(0, 10)}.csv`;
                        link.target = '_blank';
                        
                        // Append to body, click, and remove
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        
                        this.isLoading = false;
                    } else {
                        console.error('No download URL received');
                        alert('Failed to generate CSV file');
                        this.isLoading = false;
                    }
                }).catch(err => {
                    console.error('CSV Export Error:', err);
                    alert('An error occurred while exporting CSV');
                    this.isLoading = false;
                })
            },
            async fetchData() {
                this.isLoading = true
                // Update the page query parameter in the URL
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        page: this.filter.page
                    }
                });
                let option = this.filter
                await this.enrollmentListAction({
                    ...option
                }).then(res => {
                    if (res.success == true) {
                        this.dataList = res.data.data
                        this.metaData.last_page = res.data.meta.last_page
                        this.metaData.current_page = res.data.meta.current_page
                        this.metaData.prev_page_url = res.data.meta.prev_page_url
                        this.metaData.from = res.data.meta.from
                        this.metaData.to = res.data.meta.to
                        this.metaData.total = res.data.meta.total
                        this.isLoading = false;

                        this.fetchTotalData()
                    }
                }).catch(err => this.isLoading = true)
            },
            async fetchTotalData() {
                this.isLoading = true
                // Update the page query parameter in the URL
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        page: this.filter.page
                    }
                });
                let option = this.filter
                await this.enrollmentTotalAction({
                    ...option
                }).then(res => {
                    if (res.success == true) {
                        this.totalData = res.data
                        this.isLoading = false;
                    }
                }).catch(err => this.isLoading = true)
            },
            next: function (page) {
                this.filter.page = page
                this.fetchData();
            },
            reset(){
                this.$router.replace({ 
                    path: 'enrollment-report-list', 
                    query: {
                        page: 1, 
                        per_page: 10,
                        sort_direction: 'desc', 
                        sort_by: 'created_at',
                        search_batch: '',
                        search_fee: '',
                        search_student: '',
                        status: '',
                        date_from: '',
                        date_to: ''
                    } 
                }).catch(()=>{})
                this.$router.go()
            },
            editData(data) {
                this.$router.replace({ 
                    path: 'enrollment-edit', 
                    query: { 
                        page: this.filter.page,
                        per_page: this.filter.per_page,
                        sort_direction: this.filter.sort_direction, 
                        sort_by: this.filter.sort_by, 
                        id: data.id,
                        search_batch: this.filter.search_batch,
                        search_fee: this.filter.search_fee,
                        search_student: this.filter.search_student,
                        status: this.filter.status,
                        date_from: this.filter.date_from,
                        date_to: this.filter.date_to
                    } 
                }).catch(()=>{})
            },
            deleteData(data){
                this.id = data.id
                this.alert = ""
            },
            async deleteItem() {
				this.isLoading = true
				let option = {
					id: this.id,
				}
				await this.bankDeleteAction({
					...option
				}).then(res => {
					if(res.status == 'fail'){
                        this.alert = res.message
                    }else{
                        this.$refs['my-modal'].hide()
                    }
                    this.fetchData()
                    this.isLoading = false;
				}).catch(err => this.isLoading = true)
			},
            checkPermission: function (key) {
                if(key in this.permissions){
                    return true
                }else{
                    return false
                }
            },
            // CSV Upload Methods
            onFileSelect(event) {
                this.selectedFile = event.target.files[0];
                this.uploadMessage = '';
            },
            formatFileSize(bytes) {
                if (bytes === 0) return '0 Bytes';
                const k = 1024;
                const sizes = ['Bytes', 'KB', 'MB', 'GB'];
                const i = Math.floor(Math.log(bytes) / Math.log(k));
                return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
            },
            async uploadCSV() {
                if (!this.selectedFile) {
                    this.uploadMessage = 'Please select a CSV file to upload.';
                    this.uploadMessageType = 'error';
                    return;
                }

                // Validate file type
                if (!this.selectedFile.name.toLowerCase().endsWith('.csv')) {
                    this.uploadMessage = 'Please select a valid CSV file.';
                    this.uploadMessageType = 'error';
                    return;
                }

                this.isUploading = true;
                this.uploadMessage = '';

                try {
                    const formData = new FormData();
                    formData.append('csv_file', this.selectedFile);

                    const response = await this.enrollmentImportAction(formData);
                    
                    if (response.success) {
                        this.uploadMessage = response.message || 'CSV uploaded successfully!';
                        this.uploadMessageType = 'success';
                        
                        // Refresh the enrollment list
                        this.fetchData();
                        
                        // Close modal after 2 seconds
                        setTimeout(() => {
                            this.closeUploadModal();
                        }, 2000);
                    } else {
                        this.uploadMessage = response.message || 'Upload failed. Please try again.';
                        this.uploadMessageType = 'error';
                    }
                } catch (error) {
                    console.error('CSV Upload Error:', error);
                    this.uploadMessage = 'An error occurred during upload. Please try again.';
                    this.uploadMessageType = 'error';
                } finally {
                    this.isUploading = false;
                }
            },
            closeUploadModal() {
                this.selectedFile = null;
                this.uploadMessage = '';
                this.uploadMessageType = 'success';
                this.isUploading = false;
                
                // Reset file input
                if (this.$refs.csvFileInput) {
                    this.$refs.csvFileInput.value = '';
                }
                
                // Hide modal
                this.$refs['csv-modal'].hide();
            }

        },
        mounted() {
            const userStr = window.localStorage.getItem('user');
            console.log(userStr)
            if (userStr) {
                try {
                    this.user = JSON.parse(userStr);
                } catch (e) {
                    this.user = null;
                }
            }

            this.permissions = this.user && this.user.permissions ? this.user.permissions : ''
            this.filter.page = this.$route.query.page
            this.filter.per_page = this.$route.query.per_page
            this.filter.sort_by = this.$route.query.sort_by
            this.filter.sort_direction = this.$route.query.sort_direction
            this.filter.search_batch = this.$route.query.search_batch
            this.filter.search_fee = this.$route.query.search_fee
            this.filter.search_student = this.$route.query.search_student
            this.filter.status = this.$route.query.status
            this.filter.date_from = this.$route.query.date_from
            this.filter.date_to = this.$route.query.date_to
            this.fetchData()
        }
    }
</script>
<style scoped lang="scss">
/* Large commission modal custom width */
.commission-modal-lg .modal-dialog {
    max-width: 900px;
}
   .badge-16 {
    font-size: 16px;
   }
</style>